import { CartInfo } from 'types/Cart'
import { fetchUcs } from './fetchUcs'

/**
 * Retrieves the cart payload
 */
export const getCartInfo = (accountKey: string): Promise<CartInfo> =>
  fetchUcs({
    path: `v2/cart/${accountKey}`,
  })
